import React from 'react';
import classNames from 'classnames';
import { arrowLeftIcon, arrowRightIcon } from '../../../assets/index';
import Button from '../../../../components/button/index';
import './styles.scss';

const SliderControls = ({ carouselRef, slidesCollectionLength, activeSlideIndex, showAllCourses }) => {
  const slideNext = () => {
    carouselRef.current.next();
  };

  const slidePrev = () => {
    carouselRef.current.prev();
  };

  const disabledPrevControl = showAllCourses || activeSlideIndex === 0;
  const disabledNextControl = showAllCourses || activeSlideIndex === slidesCollectionLength - 1;

  return (
    <div className="profile-courses-carousel__controls-wrapper">
      <Button
        type="green"
        className={classNames(
          'profile-courses-carousel__control',
          disabledPrevControl && 'profile-courses-carousel__control_disabled',
        )}
        text={<img src={arrowLeftIcon} alt="switch-previous" />}
        onClick={slidePrev}
        disabled={disabledPrevControl}
      />
      <Button
        type="green"
        className={classNames(
          'profile-courses-carousel__control',
          disabledNextControl && 'profile-courses-carousel__control_disabled',
        )}
        text={<img src={arrowRightIcon} alt="switch-next" />}
        onClick={slideNext}
        disabled={disabledNextControl}
      />
    </div>
  );
};

export default SliderControls;
